import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, EmailAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { Timestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAeXtYrxpU2o6c6WkymFBmQe9pJzGIxny4",
  authDomain: "vinayaka-matrimony.firebaseapp.com",
  projectId: "vinayaka-matrimony",
  storageBucket: "vinayaka-matrimony.appspot.com",
  messagingSenderId: "39387931885",
  appId: "1:39387931885:web:5be1ba71bd14931565d8e4",
  measurementId: "G-EK9S5R4VLH"
};

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const provider = new GoogleAuthProvider();
const emailProvider = new EmailAuthProvider();
const storage = getStorage(firebaseApp);
const timestamp = Timestamp.now();

export { auth, provider, emailProvider, storage, timestamp, db };